import * as React from 'react';
import * as ReactDOM from 'react-dom';

// eslint:disable-next-line:no-empty-interface
interface KeepFocusOnElementComponentProps { 
  children?: React.ReactNode;
}

interface KeepFocusOnElementComponentState {
  hasFocus: boolean;
 }

class KeepFocusOnElementComponent extends React.Component<KeepFocusOnElementComponentProps, KeepFocusOnElementComponentState> {
  private divRef: HTMLDivElement;
  public state: Readonly<KeepFocusOnElementComponentState> = {
    hasFocus: false
  };

  private handleFocus = () => {
    this.setState({
      hasFocus: true
    });
  };
  private handleBlur = () => {
    this.setState({
      hasFocus: false
    });
  };

  public componentDidUpdate() {
    if (this.state.hasFocus) {
      const el:any = ReactDOM.findDOMNode(this);
      if (!el.contains(document.activeElement)) {
        !!this.divRef && this.divRef.focus();
      }
    }
  }

  private setDivRef = (el: HTMLDivElement) => {
    this.divRef = el;
  };

  public render(): JSX.Element {
    return (<div
      onFocus={this.handleFocus}
      onBlur={this.handleBlur}
      ref={this.setDivRef}
      tabIndex={-1}
    >
      {this.props.children}
    </div>);
  }
}

export const KeepFocusOnElement = KeepFocusOnElementComponent;
